var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_5555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1673 4.33533H4.33354C3.89148 4.33533 3.46752 4.51094 3.15494 4.82352C2.84236 5.1361 2.66675 5.56006 2.66675 6.00212V17.6697C2.66675 18.1117 2.84236 18.5357 3.15494 18.8483C3.46752 19.1609 3.89148 19.3365 4.33354 19.3365H16.0011C16.4432 19.3365 16.8671 19.1609 17.1797 18.8483C17.4923 18.5357 17.6679 18.1117 17.6679 17.6697V11.8359",
    stroke: "#285DA2",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4178 3.08483C16.7494 2.75328 17.1991 2.56702 17.6679 2.56702C18.1368 2.56702 18.5865 2.75328 18.918 3.08483C19.2496 3.41638 19.4359 3.86605 19.4359 4.33493C19.4359 4.80382 19.2496 5.25349 18.918 5.58504L11.0007 13.5024L7.66708 14.3358L8.50049 11.0022L16.4178 3.08483Z",
    stroke: "#285DA2",
    strokeWidth: 1.66678,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_5555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0017,
    height: 20.0017,
    fill: "white",
    transform: "translate(1 1.00171)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6c5588bc697767ad43f76047c273e963.svg";
export { ForwardRef as ReactComponent };